export const QUICKBOOKS_OPERATION_STATUSES = [
  "queued",
  "waiting_dependency",
  "preparing",
  "submitting",
  "retry_wait",
  "reconciling",
  "succeeded",
  "failed",
  "needs_review",
  "blocked",
] as const;

export type QuickBooksOperationStatus =
  (typeof QUICKBOOKS_OPERATION_STATUSES)[number];

export interface QuickBooksOperation {
  operation_id: string;
  batch_id?: string | null;
  account: "sun" | "solmaz";
  source_type: "shipment" | "sun_order";
  source_id: number;
  document_type: "purchase_order" | "invoice";
  depends_on_operation_id?: string | null;
  generation: number;
  status: QuickBooksOperationStatus;
  message?: string | null;
  can_retry: boolean;
  can_replace: boolean;
  quickbooks_id?: string | null;
  document_number?: string | null;
  status_url: string;
}

export interface QuickBooksOperationBatch {
  batch_id: string;
  operations: QuickBooksOperation[];
}

export interface SunShipmentOperations {
  source_type: "shipment";
  source_id: number;
  operations: QuickBooksOperation[];
}

export interface QuickBooksOperationCapabilities {
  sun: boolean;
  solmaz: boolean;
}

export interface QuickBooksOperationApiError extends Error {
  status?: number;
  code?: string;
  retryAfter?: number;
  isNetworkError: boolean;
  isCanceled: boolean;
  body?: { code?: string; message?: string; [key: string]: unknown };
}

export function isActiveQuickBooksStatus(status?: QuickBooksOperationStatus): boolean {
  return status !== undefined && [
    "queued",
    "waiting_dependency",
    "preparing",
    "submitting",
    "retry_wait",
    "reconciling",
  ].includes(status);
}

export function hasQuickBooksOperations(state?: {
  operations?: QuickBooksOperation[];
  loading?: boolean;
  polling?: boolean;
  mutatingId?: string | null;
  error?: QuickBooksOperationApiError | null;
}): boolean {
  return Boolean(
    state?.loading ||
      state?.polling ||
      state?.mutatingId ||
      state?.error ||
      state?.operations?.length,
  );
}
